























































import { defineComponent, PropType, computed } from "@vue/composition-api";
import dayjs from "dayjs";
import { CommentItem } from "./types";
import { CommentMemberType } from "@/pb/scout/message/v1/message_pb";
import { unixTimeMSToTimeStr } from "@/helpers/date-helper.ts";
import { newLineToBR, replaceURLWithLinks } from "@/helpers/string-helper.ts";
import DOMPurify from "dompurify";

export default defineComponent({
  name: "Comment",
  emits: ["delete"],
  props: {
    comment: {
      type: Object as PropType<CommentItem>,
      required: true
    },
    userImageUrl: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const handleClickedDelete = () => {
      emit("delete", props.comment.id);
    };

    const commentMemberTypeClass = computed(() => {
      const classes = [];
      if (isPartnersComment.value) {
        classes.push("partner-message");
      }
      if (isUsersComment.value) {
        classes.push("user-message");
      }

      return classes;
    });

    // DOMPurifyを使って、コメント本文に含まれるaタグとbrタグを許可し、それ以外のタグは削除する
    const processedCommentTextHTML = computed(() => {
      const replacedHTML = newLineToBR(replaceURLWithLinks(props.comment.text));
      // aタグのhref属性とbrタグのみを許可する
      return DOMPurify.sanitize(replacedHTML, {
        ALLOWED_TAGS: ["a", "br"],
        ALLOWED_ATTR: ["href"]
      });
    });

    // 送信予定日時を過ぎた場合、送信処理とバッティングする可能性があるので送信済みか否かに関係なく削除ボタンは表示しない
    const isShownDeleteIcon = computed(() => {
      return (
        isPartnersComment.value &&
        isReservation.value &&
        dayjs(props.comment.timestampMS).isAfter(dayjs())
      );
    });

    const isReservation = computed(() => {
      return isPartnersComment.value && !props.comment.alreadySent;
    });

    const isPartnersComment = computed(() => {
      return (
        props.comment.memberType ===
        CommentMemberType.COMMENT_MEMBER_TYPE_PARTNER
      );
    });

    const isUsersComment = computed(() => {
      return (
        props.comment.memberType === CommentMemberType.COMMENT_MEMBER_TYPE_USER
      );
    });

    const isUserReadComment = computed(() => {
      return (
        isPartnersComment.value &&
        !!props.comment.userReadAtMS &&
        props.comment.userReadAtMS > 0
      );
    });

    return {
      commentMemberTypeClass,
      unixTimeMSToTimeStr,
      processedCommentTextHTML,
      isShownDeleteIcon,
      handleClickedDelete,
      isUserReadComment,
      isUsersComment,
      isReservation
    };
  }
});
